import * as g from "three";
import { defineQuery as l } from "bitecs";
import "../../core/ecs/components.js";
import "../../core/validation/schemas.js";
import { WorldTransform as a } from "../transforms/components.js";
import "../transforms/systems.js";
import { Renderer as y, AmbientLight as w, DirectionalLight as d, MainCamera as p, RenderContext as v } from "./components.js";
import { hideInstance as x, getOrCreateMesh as L, updateInstance as z, updateShadowCamera as P } from "./operations.js";
import { getRenderingContext as u, getScene as R, SHADOW_CONFIG as C, threeCameras as A, createThreeCamera as Q, syncCameraSettings as W, deleteCanvasElement as H, getCanvasElement as T, createRenderer as D, handleWindowResize as N } from "./utils.js";
const X = l([y]), Y = l([w]), Z = l([d]), I = l([p, a]), _ = l([p]), E = l([v]), B = {
  group: "draw",
  update(e) {
    if (e.headless) return;
    const o = u(e);
    for (const [r, s] of o.entityInstances)
      if (!e.exists(r)) {
        const t = (s.unlit ? o.unlitMeshPools : o.meshPools).get(s.poolId);
        t && x(t, r, o), o.entityInstances.delete(r), o.totalInstanceCount--;
      }
    const n = X(e.world);
    for (const r of n) {
      const s = y.unlit[r] === 1;
      let i = L(o, y.shape[r], s);
      if (i) {
        if (y.visible[r] !== 1) {
          x(i, r, o);
          continue;
        }
        i = z(i, r, o, e, s);
      }
    }
    P(o, e);
  }
}, J = {
  group: "draw",
  update(e) {
    if (e.headless) return;
    const o = u(e), n = R(e);
    if (!n) return;
    const r = Y(e.world);
    for (const i of r) {
      let t = o.lights.ambient;
      t || (t = new g.HemisphereLight(), n.add(t), o.lights.ambient = t), t.color.setHex(w.skyColor[i]), t.groundColor.setHex(w.groundColor[i]), t.intensity = w.intensity[i];
    }
    const s = Z(e.world);
    for (const i of s) {
      let t = o.lights.directional;
      t || (t = new g.DirectionalLight(), t.castShadow = !0, n.add(t), n.add(t.target), o.lights.directional = t), t.color.setHex(d.color[i]), t.intensity = d.intensity[i], d.castShadow[i] === 1 ? (t.castShadow = !0, t.shadow.mapSize.width = d.shadowMapSize[i], t.shadow.mapSize.height = d.shadowMapSize[i]) : t.castShadow = !1;
      const M = I(e.world);
      let m = null;
      for (const f of M) {
        m = f;
        break;
      }
      if (m !== null) {
        const f = new g.Vector3(
          a.posX[m],
          a.posY[m],
          a.posZ[m]
        ), b = new g.Vector3(
          d.directionX[i],
          d.directionY[i],
          d.directionZ[i]
        ).normalize(), S = f.clone().add(
          b.multiplyScalar(d.distance[i])
        );
        t.position.copy(S), t.target.position.copy(f), t.target.updateMatrixWorld();
        const c = t.shadow.camera, h = C.CAMERA_RADIUS;
        c.left = -h, c.right = h, c.top = h, c.bottom = -h, c.near = C.NEAR_PLANE, c.far = C.FAR_PLANE, c.position.copy(S), c.lookAt(f), c.updateProjectionMatrix(), c.updateMatrixWorld();
      }
    }
  }
}, K = {
  group: "draw",
  update(e) {
    if (e.headless) return;
    const o = I(e.world);
    for (const n of o) {
      let r = A.get(n);
      r || (r = Q(
        n,
        e,
        p.projection[n],
        p.fov[n],
        p.orthoSize[n]
      )), r.position.set(
        a.posX[n],
        a.posY[n],
        a.posZ[n]
      ), r.quaternion.set(
        a.rotX[n],
        a.rotY[n],
        a.rotZ[n],
        a.rotW[n]
      ), W(r, n, e);
    }
  }
}, $ = {
  group: "draw",
  last: !0,
  setup(e) {
    if (e.headless) return;
    const o = E(e.world);
    if (o.length === 0) return;
    const n = o[0], r = T(n);
    if (!r) return;
    const s = v.clearColor[n], i = D(r, s), t = u(e);
    t.renderer = i, t.canvas = r, window.addEventListener(
      "resize",
      () => N(e, i)
    );
  },
  update(e) {
    if (e.headless) return;
    const o = u(e);
    if (!o.renderer) return;
    const n = R(e);
    if (!n) return;
    const r = _(e.world);
    if (r.length === 0) return;
    const s = r[0], i = A.get(s);
    i && o.renderer.render(n, i);
  },
  dispose(e) {
    if (e.headless) return;
    const o = u(e);
    o.renderer && (o.renderer.dispose(), o.renderer = void 0, o.canvas = void 0);
    const n = E(e.world);
    for (const r of n)
      H(r);
  }
};
export {
  K as CameraSyncSystem,
  J as LightSyncSystem,
  B as MeshInstanceSystem,
  $ as WebGLRenderSystem
};
//# sourceMappingURL=systems.js.map
